export default __webpack_public_path__ + "static/media/toa-heftiba-W6sqUYlJRiw-unsplash.75089d21.jpg";